import { useQueryClient } from '@tanstack/react-query';
import { useOptimisticMutation, type Variables } from '../../../hooks/use-optimistic-mutation';
import type { ShippingMethodApiResponse } from '../types/shipping-method';
import { QK_LIST_SHIPPING_METHODS } from './use-shipping-methods';
import { useShippingMethodsApi } from './use-shipping-methods-api';

export function useDeleteShippingMethod() {
  const { shippingMethodsApi } = useShippingMethodsApi();
  const queryClient = useQueryClient();

  async function deleteMethod(id: string) {
    await shippingMethodsApi.shippingMethod(id).delete();
  }

  return useOptimisticMutation<ShippingMethodApiResponse[], Variables<typeof deleteMethod>>({
    mutationFn: deleteMethod,
    queryKey: QK_LIST_SHIPPING_METHODS(),
    queryClient,
    optimisticUpdate: (prev, id) => prev?.filter((method) => method.id !== id) ?? [],
  });
}
